import React from "react";
import { Alert } from "react-bootstrap";

const CreateAlert = ({ field, index, variant }) => {
  return field && field.text && Object.keys(field.text).length > 0 ? (
    <Alert
      key={index}
      variant={variant || "info"}
      style={{
        backgroundColor:
          field.cssclass === "background:transparent" ? "transparent" : "",
        border:
          field.cssclass === "background:transparent" ? "transparent" : "",
        color: field.cssclass === "background:transparent" ? "#4c4b4b" : "",
      }}
    >
      {Object.keys(field.text).map((k) => {
        return field.text[k];
      })}
    </Alert>
  ) : field && field.text ? (
    <Alert key={index} variant={variant || "info"}>
      {field.text}
    </Alert>
  ) : null;
};
export default CreateAlert;
